module.exports = __webpack_public_path__ + "static/img/18雅申.f1e187c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/18雅申.jpg
// module id = fOxG
// module chunks = 1